interface VesselEvaluationPaginationProps {
  limit: number;
  loading: boolean;
  offset: number;
  onOffsetChange: (offset: number) => void;
  total: number;
}

// Keeps navigation deterministic by using the offset and limit acknowledged by the API response.
const VesselEvaluationPagination = ({
  limit,
  loading,
  offset,
  onOffsetChange,
  total,
}: VesselEvaluationPaginationProps) => {
  const firstRow = total === 0 ? 0 : offset + 1;
  const lastRow = Math.min(offset + limit, total);

  return (
    <div className="flex items-center gap-3 text-xs" data-test="vessel-evaluation-pagination">
      <span>{firstRow.toLocaleString()}-{lastRow.toLocaleString()} of {total.toLocaleString()}</span>
      <button
        type="button"
        disabled={offset === 0 || loading}
        onClick={() => onOffsetChange(Math.max(0, offset - limit))}
        className="rounded border border-gray-300 px-3 py-1 font-medium disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-600"
        data-test="vessel-evaluation-previous-page"
      >
        Previous
      </button>
      <button
        type="button"
        disabled={offset + limit >= total || loading}
        onClick={() => onOffsetChange(offset + limit)}
        className="rounded border border-gray-300 px-3 py-1 font-medium disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-600"
        data-test="vessel-evaluation-next-page"
      >
        Next
      </button>
    </div>
  );
};

export default VesselEvaluationPagination;
